import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { useTrackDisabledSelectAll } from '@air/analytics';
import { selectedItemsCountSelector, unselectItemAction } from '@air/redux-selected-items';

import { useViewsSelectAllStore } from '~/components/v2/store/features/views/useViewsSelectAllStore';
import { useAirStore } from '~/utils/ReduxUtils';

export const useUnselectAgentSelectedItem = (itemId: string) => {
  const dispatch = useDispatch();
  const store = useAirStore();
  const { trackDisabledSelectAll } = useTrackDisabledSelectAll();
  const selectAll = useViewsSelectAllStore((state) => state.selectAll);
  const resetSelectAll = useViewsSelectAllStore((state) => state.resetSelectAll);

  const unselectAgentSelectedItem = useCallback(() => {
    if (selectAll) {
      trackDisabledSelectAll({
        trigger: 'item-unselect',
        totalSelectionCount: selectedItemsCountSelector(store.getState()),
      });
    }
    resetSelectAll();
    dispatch(unselectItemAction({ itemId }));
  }, [dispatch, itemId, resetSelectAll, selectAll, store, trackDisabledSelectAll]);

  return { unselectAgentSelectedItem };
};
